import { readOnlyFieldMTF } from 'app/services/sfAuth/sfData/jsConnectionUtils'
import { mapSFToForm } from 'app/services/sfAuth/sfDataService'
import { ApplicationTeamMember, applicationTeamMemberMapSF } from './ApplicationTeamMember'
import { ExternalApproval, externalApprovalMapSF } from './ExternalApproval'
import { FundingStream, fundingStreamFieldsMapSF } from './FundingStream'

export const applicationFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Account: {
    fieldName: 'account',
    Name: 'name',
    Id: 'id'
  },
  RecordTypeId: 'recordTypeId',
  // 'RecordType.Name': 'recordTypeName',
  Name: 'name',
  Description: 'description',
  StageName: 'stageName',
  ...readOnlyFieldMTF('PM_Name__c', 'pmName'),
  ...readOnlyFieldMTF(
    'External_Validation_Status__c',
    'externalValidationStatus'
  ),
  ...readOnlyFieldMTF('PM_Contact__c', 'pmContact'),
  ...readOnlyFieldMTF('PM_notes_to_reviewers__c', 'pmNotesToReviewers'),
  ...readOnlyFieldMTF('Grant_Awarded__c', 'grantAwarded'),
  CampaignId: 'campaignId',
  CreatedDate: 'createdDate',
  LastModifiedDate: 'lastModifiedDate',
  FGM_Base__Amount_Requested__c: 'amountRequested',
  FGM_Base__Recommended_Amount__c: 'recommendedAmount',
  FGM_Portal__Total_Project_Budget__c: {
    key: 'budgetTotal',
    in: (opp) => opp.FGM_Portal__Total_Project_Budget__c / 2
  },
  PID__c: 'pid',
  Mortgage_underwritten_by_DMAH__c: 'mortgageUnderwrittenByDMAH',
  Hardcoded_executive_summary__c: 'shouldUseHardcodedExecutiveSummary',
  Funding_Stream__c: 'fundingStream',
  Form_Version__c: 'formVersion',
  Pre_Qualification__c: 'prequalification',
  Funding_Stream__r: {
    key: 'fundingStreamFull',
    in: opp => {
      return opp.Funding_Stream__r == null
        ? null
        : mapSFToForm(fundingStreamFieldsMapSF, opp.Funding_Stream__r) as FundingStream
    }
  },
  ...readOnlyFieldMTF('Assigned_Program_Manager__c', 'assignedProgramManager'),
  Anticipated_Closing_Date__c: 'anticipatedClosingDate',
  Manual_share_with_DMAH__c: 'sharedWithDMAH',
  CMHC_signer__c: 'cmhcSigner',
  Priority_areas__c: 'priorityAreas',
  Objectives__c: 'objectives',
  Partners__c: 'partners',
  Grant_Form__c: 'grantForm',
  Hardcoded_form__c: 'hardCoded',
  Geographical_Location__c: 'geographicalScopeDetails',
  Municipality__c: 'municipality',
  RecordType: {
    fieldName: 'recordType',
    Name: 'name'
  },
  FGM_Base__Reviews__r: {
    nonField: true,
    key: 'reviews',
    in: (opp) => {
      return (
        opp.FGM_Base__Reviews__r != null
          ? opp.FGM_Base__Reviews__r.records.map((obj) => ({
            id: obj.Id,
            apiName: obj.RecordType?.DeveloperName,
            recordTypeId: obj.RecordTypeId,
            status: obj.FGM_Base__Status__c
          }))
          : []
      )
    }
  },
  OpportunityHistories: {
    nonField: true,
    key: 'history',
    in: (opp) => opp.OpportunityHistories != null
      ? opp.OpportunityHistories?.records.map((obj) => ({
        stage: obj.StageName,
        date: obj.CreatedDate
      }))
      : []
  },
  OpportunityTeamMembers: {
    nonField: true,
    key: 'teamMembers',
    in: (opp) => opp.OpportunityTeamMembers?.records?.map(
      (obj) => mapSFToForm(applicationTeamMemberMapSF, obj) as ApplicationTeamMember
    ) ?? []
  },
  ProcessInstances: {
    nonField: true,
    key: 'processInstances',
    in: (opp) => opp.ProcessInstances != null
      ? opp.ProcessInstances?.records.map((obj) => ({
        status: obj.Status
      }))
      : []
  },
  External_Approvals__r: {
    nonField: true,
    key: 'externalApprovals',
    in: (opp) => opp.External_Approvals__r?.records?.map(
      (obj) => mapSFToForm(externalApprovalMapSF, obj) as ExternalApproval[]
    ) ?? []
  }
}

export interface Application {
  id: string
  account: {
    fieldName: string
    name: string
    id: string
  }
  recordTypeId: string
  recordTypeName?: string
  name: string
  description?: string
  stageName: string
  pmName?: string
  externalValidationStatus?: string
  pmContact?: string
  pmNotesToReviewers?: string
  shouldUseHardcodedExecutiveSummary?: boolean
  campaignId?: string
  createdDate: Date | moment.Moment
  lastModifiedDate: Date | moment.Moment
  amountRequested?: number
  recommendedAmount?: number
  fundingStream?: string
  fundingStreamFull?: FundingStream
  cmhcSigner?: string
  budgetTotal?: string
  teamMembers?: ApplicationTeamMember[]
  history: Array<{ stage: string, date: string }>
  priorityAreas?: string
  assignedProgramManager?: string
  objectives?: string
  partners?: string
  geographicalScopeDetails?: string
  recordType: {
    fieldName: string
    name?: string
  }
  externalApprovals?: ExternalApproval[]
  grantForm?: string
  formVersion?: string
  hardCoded?: boolean
  prequalification?: string
}

export const IncludeRelationshipsForApplication = ['FGM_Base__Reviews__r', 'OpportunityTeamMembers', 'External_Approvals__r'] as const
